import React, { useEffect, useRef, useState } from "react";
import { StyledButton } from "../../components/styledComponent/styledElements";
import CustomTable from "../../components/styledComponent/styledTable";
import StyledContentCard from "../../components/styledComponent/styledContentCard";
import { AiOutlinePlusSquare } from "react-icons/ai";
import {
  createProduct,
  deleteProduct,
  listAllProduct,
  listSearchedProduct,
} from "../../server/productServices";
import { ShowNotification } from "../../components/notification/notification";
import TableActions from "../../components/tableAction/tableActions";
import DeleteModal from "../../components/styledComponent/deleteModal";
import ProductCreationModal from "./productCreationModal";
import { useNavigate } from "react-router-dom";
import { useAppContext } from "../../contexts/appContext";
import Searchbar from "../../components/searchbar/searchbar";

function ProductPage() {
  const column = [
    {
      title: "Id",
      dataIndex: "id",
      key: "id",
      width: "5%",
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      width: "30%",
      ellipsis: true,
    },
    {
      title: "Code",
      dataIndex: "code",
      key: "code",
    },
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
      ellipsis: true,
    },
    {
      title: "Category Id",
      dataIndex: "category_id",
      key: "category_id",
    },
    {
      title: "Purchase Rate",
      dataIndex: "purchase_rate",
      key: "purchase_rate",
      width: "10%",
    },
    {
      title: "MRP",
      dataIndex: "mrp",
      key: "mrp",
      width: "10%",
    },
    {
      key: "actions",
      width: 100,
      render: (text, record) => (
        <TableActions
          showDelete={userRole === "Admin" || productAccess?.delete}
          showEdit={userRole === "Admin" || productAccess?.edit}
          onClickDelete={(e) => {
            e.stopPropagation();
            setDeleteId(record.id);
            setShowDeletePopup(true);
          }}
          onClickEdit={(e) => {
            e.stopPropagation();
            setAddProductModal(true);
            setUpdate(record.id);
          }}
        />
      ),
    },
  ];
  const [addProductModal, setAddProductModal] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [showDeletePopup, setShowDeletePopup] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [refetch, setRefetch] = useState(false);
  const [update, setUpdate] = useState(null);
  const [search, setSearch] = useState("");

  const { startLoading, stopLoading, user } = useAppContext();
  const formRef = useRef();
  const timeoutRef = useRef(null);

  const navigate = useNavigate();
  var userRole = user?.role;
  var productAccess = user?.access?.product;

  const fetchProducts = async () => {
    startLoading();
    try {
      if (search.length > 0) {
        const res = await listSearchedProduct(search);
        setTableData(res.data);
      } else {
        const res = await listAllProduct();
        setTableData(res.data);
      }
    } catch (err) {
      console.log("Error fetching products:", err);
    } finally {
      stopLoading();
    }
  };
  useEffect(() => {
    fetchProducts();
    setRefetch(false);
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, [refetch, search]);

  const onSearch = (e) => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    const value = e.target.value;

    timeoutRef.current = setTimeout(() => {
      setSearch(value);
    }, 500);
  };
  const handleAddProduct = (values, fileList) => {
    const files = fileList.map((file) => file.originFileObj);

    startLoading();
    createProduct(values, files)
      .then(() => {
        ShowNotification({
          type: "success",
          message: "Product Successfully Added",
        });
        setAddProductModal(false);
        fetchProducts();
        formRef.current.resetFields();
      })
      .finally(() => {
        stopLoading();
      });
  };
  const handleDeleteProduct = () => {
    deleteProduct(deleteId)
      .then(() => {
        ShowNotification({
          type: "success",
          message: "Product Deleted Successfully ",
        });
      })
      .finally(() => {
        setDeleteId(null);
        setShowDeletePopup(false);
        setRefetch(true);
      });
  };

  return (
    <div>
      {showDeletePopup && (
        <DeleteModal
          showDelete={showDeletePopup}
          onCancel={() => {
            setDeleteId(null);
            setShowDeletePopup(false);
          }}
          onsubmit={handleDeleteProduct}
        />
      )}
      <StyledContentCard title={"Product"}>
        <div className="flex float-right mb-2 gap-2">
          <Searchbar onChange={onSearch} onSearch={(val) => setSearch(val)} />
          {(userRole === "Admin" || productAccess?.create) && (
            <StyledButton
              icon={<AiOutlinePlusSquare size={20} />}
              iconPosition="start"
              onClick={() => setAddProductModal(true)}
            >
              Product
            </StyledButton>
          )}
          {addProductModal && (
            <ProductCreationModal
              showCreationModal={addProductModal}
              setShowCreationModal={setAddProductModal}
              onSubmit={handleAddProduct}
              formRef={formRef}
              update={update}
              setUpdate={setUpdate}
              setRefetch={setRefetch}
            />
          )}
        </div>
        <CustomTable
          data={tableData}
          columns={column}
          rowKey="id"
          pageSize={20}
          onRow={(record) => {
            return {
              onClick: () => {
                navigate(`/product/${record.id}`);
              },
              className: "clickable",
            };
          }}
        />
      </StyledContentCard>
    </div>
  );
}

export default ProductPage;
